<template>
    <teleport to="body">
        <div class="fixed bottom-0 w-full md:hidden">
            <slot />
        </div>
    </teleport>
    <div class="hidden md:block">
        <slot />
    </div>
</template>
